//common functionalities for all the javascript featueres

export var XonBoard = {}; // common variable used in all the files of the backend
window.XonBoard = XonBoard;

(function () {

    XonBoard.Utils = {

        destroyTable: function() {
            if ($.fn.DataTable.isDataTable('#sensor-reads-table')) {
                $('#sensor-reads-table').removeData('ajax_url');
                $('#sensor-reads-table').DataTable().clear().destroy();
            }
        },

        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        options: {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        },
        init() {
            this.setCSRF();
            this.initDataTablesErrorHandler();
        },
        initDataTablesErrorHandler() {
            if (!$.fn.dataTable) {
                return;
            }

            $.fn.dataTable.ext.errMode = function (e, settings, techNote, message) {
                if (e && e.jqXHR && e.jqXHR.status == 401) {
                    window.setTimeout(function () {
                        document.location.href = '/';
                    }, 5000);
                    return;
                }

                alert(techNote);
            };
        },
        toggleClass: function (element, className) {

            if (element.classList) {
                element.classList.toggle(className);
            } else {
                var classes = element.className.split(' ');
                var existingIndex = classes.indexOf(className);

                if (existingIndex >= 0)
                    classes.splice(existingIndex, 1);
                else
                    classes.push(className);

                element.className = classes.join(' ');
            }
        },
        Select2: {
            reset() {
                var select2 = $('.xob-select2');
                select2.each(function () {
                    $(this).val('').trigger('change');
                });
            },
            resetField(field) {
                var select2 = $(field);
                select2.each(function () {
                    $(this).val('').trigger('change');
                });
            },
            initSelectors(parent) {
                var select2 = $('.xob-select2');
                select2.each(function () {
                    $(this).select2({
                        theme: 'bootstrap',
                        dropdownParent: parent,
                        ajax: {
                            url: function () {
                                return $(this).data('url');
                            },
                            delay: 500,
                            dataType: 'json',
                        },
                    });
                });
            },
            init() {
                var self = this;

                this.initSelectors();
                $('.xob-modal').on('show.bs.modal', function () {
                    self.initSelectors($(this).parent());
                }).on('hidden.bs.modal', function () {
                    // self.destroySelectors();
                });
            },
        },
        importFileUsingButton: function (url, data = {}) {
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

            input.onchange = e => {
                var file = e.target.files[0];
                let form = new FormData;
                form.append('file', file, file.name);

                Object.keys(data).forEach(function (key) {
                    form.append(key, data[key]);
                });

                const callback = {
                    success: function (data) {
                        let message = JSON.parse(data.response).flash_success;
                        XonBoard.Utils.handleSuccess(message);
                    },
                    error: function (xhr, status, data) {
                        XonBoard.Utils.handleErrorInToast(xhr, data)
                    }
                };

                XonBoard.Utils.handleInfo("Submitting the file!");
                XonBoard.Utils.ajaxrequest(
                    url,
                    "post",
                    form,
                    XonBoard.Utils.csrf,
                    callback,
                );
            }

            input.click();
        },
        handleSuccess: function (data) {
            if (data) {
                toastr.options = this.options;
                toastr.success(data);
            }
        },
        handleInfo: function (data) {
            if (data) {
                toastr.info(data);
            }
        },
        handleError: function (xhr, data, divName = '.validation-errors') {
            if (xhr.status == 401) {
                window.location.replace("/login");
            }

            if (xhr.status == 422) {
                $(divName).empty();
                var arr = $.parseJSON(xhr.responseText).errors;
                var div = $(divName).append('<div class="alert alert-danger" role="alert" ><div>').children();
                $.each(arr, function (index, value) {
                    if (value.length != 0) {
                        div.append('' + value.join('<br>') + '<br>');
                    }
                });
                return;
            }

            if (xhr.status == 500) {
                toastr.error('Something went wrong on the server');
                return;
            }

            window.toastr.options = this.options;
            if (xhr.responseText && $.parseJSON(xhr.responseText).error) {
                toastr.error($.parseJSON(xhr.responseText).error)
                return;
            }

            if (xhr.status == 404) {
                toastr.error('The requested resource is not found.');
                return;
            }

            if (xhr.status == 405) {
                toastr.error('Method not allowed');

            }
        },
        handleErrorInToast: function (xhr, data) {
            if (xhr.status == 401) {
                window.location.replace("/login");
            }

            if (xhr.status == 422) {
                var errors = $.parseJSON(xhr.responseText).errors.join('<br>');
                toastr.error(errors);
                return;
            }

            if (xhr.status == 500) {
                toastr.error('Something went wrong on the server');
                return;
            }

            window.toastr.options = this.options;
            if (xhr.responseText && $.parseJSON(xhr.responseText).error) {
                toastr.error($.parseJSON(xhr.responseText).error)
                return;
            }

            if (xhr.status == 404) {
                toastr.error('The requested resource is not found.');
                return;
            }

            if (xhr.status == 405) {
                toastr.error('Method not allowed');

            }
        },
        EditByUrl(url, onSuccess = null) {
            $.ajax({
                url: url,
                type: "GET",
                dataType: 'html',
                success: function (data) {
                    $('body').prepend(data);
                    XonBoard.Utils.Select2.init();
                    $('#edit-modal').modal('toggle');
                    //       window.location.reload(true);
                    $('#cancel').click(function () {
                        $('#create-modal').modal('hide');
                        $('#edit-modal').modal('hide')
                        $('#edit-modal').on('hidden.bs.modal', function (e) {
                            $('#edit-modal').remove()
                        })
                    });

                    $("#edit-form").submit(function (e) {
                        e.preventDefault();
                        $("#edit-form").ajaxSubmit({
                            success: function (data) {
                                $('.xob-modal').modal('hide')

                                XonBoard.Utils.handleSuccess(data.flash_success)

                                if (onSuccess) {
                                    onSuccess();
                                }

                                $(".submit-button").prop("disabled", false);
                            },
                            error: function (xhr, status, data) {
                                XonBoard.Utils.handleError(xhr, data)

                                $(".submit-button").prop("disabled", false);
                            }
                        });
                    });
                }
            });
        },
        Edit: function (button, table) {
            XonBoard.Utils.EditByUrl(
                $(button).data('url'),
                function () {
                    $('#' + table).dataTable().api().draw()
                },
            );
        },
        EditByComponent: function (button) {
            XonBoard.Utils.EditByUrl(
                $(button).data('url'),
                function () {
                },
            );
        },
        show: function (button) {
            $.ajax({
                url: $(button).data('url'),
                type: "GET",
                dataType: 'html',
                success: function (data) {
                    $('body').prepend(data);
                    $('#show-modal').modal('toggle');
                    $('#cancel').click(function () {
                        $('#show-modal').modal('hide')
                        $('#show-modal').on('hidden.bs.modal', function (e) {
                            $('#show-modal').remove()
                        })
                    });

                }
            });
        },
        addClass: function (element, className) {

            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },

        removeClass: function (el, className) {

            if (el.classList)
                el.classList.remove(className);
            else
                el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },

        documentReady: function (callback) {
            if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
                callback();
            } else {
                document.addEventListener('DOMContentLoaded', callback);
            }
        },

        ajaxrequest: function (url, method, data, csrf, callback) {
            var request = new XMLHttpRequest();
            var loadingIcon = jQuery(".loading");

            if (window.XMLHttpRequest) {
                // code for modern browsers
                request = new XMLHttpRequest();
            } else {
                // code for old IE browsers
                request = new ActiveXObject("Microsoft.XMLHTTP");
            }
            request.open(method, url, true);

            request.onloadstart = function () {
                loadingIcon.show();
            };
            request.onloadend = function () {
                loadingIcon.hide();
            };
            request.setRequestHeader('X-CSRF-TOKEN', csrf);
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            if ("post" === method.toLowerCase() || "patch" === method.toLowerCase()) {
                if (data instanceof FormData) {
                    // request.setRequestHeader('Content-Type', 'multipart/form-data');
                } else {
                    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    data = this.jsontoformdata(data);
                }
            }

            // when request is in the ready state change the details or perform success function
            request.onreadystatechange = function () {

                if (request.readyState === this.DONE) {
                    if (request.status >= 200 && request.status < 300) {
                        request.onload = callback.success(request);
                    } else {
                        callback.error(request, request.status, request.response);
                    }
                }
            };

            request.onerror = function () {
            };
            request.send(data);
        },

        // This should probably only be used if all JSON elements are strings
        jsontoformdata: function (srcjson) {
            if (typeof srcjson !== "object")
                if (typeof console !== "undefined") {
                    return null;
                }
            let u = encodeURIComponent;
            var urljson = "";
            var keys = Object.keys(srcjson);
            for (var i = 0; i < keys.length; i++) {
                urljson += u(keys[i]) + "=" + u(srcjson[keys[i]]);
                if (i < (keys.length - 1)) urljson += "&";
            }
            return urljson;
        },

        setCSRF: function () {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': this.csrf
                }
            });
        },

        dtAnchorToForm: function ($parent) {

            $('td:last', $parent).addClass('btn-td');

            $('[data-method]', $parent).append(function () {
                if (!$(this).find('form').length > 0) {
                    var method = this.getAttribute('data-method');

                    if (method == 'delete') {
                        return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                            "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                            "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                            '</form>\n';
                    } else {
                        return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                            "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                            '</form>\n';
                    }
                } else {
                    return ''
                }
            })
                .attr('href', '#')
                .attr('style', 'cursor:pointer;')
                .attr('onclick', '$(this).find("form").submit();');
        },

    };
    XonBoard.tinyMCE = {
        init: function (locale = 'en_US') {

            tinymce.init({
                language: (locale === 'en_US' ? undefined : locale),
                path_absolute: "/",
                selector: '.mce',
                height: 200,
                width: 725,
                // theme: 'silver', // New theme available in latest tinymce
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern imagetools codesample toc'
                ],
                toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                //                toolbar2: 'print preview media | forecolor backcolor emoticons | codesample',
                image_advtab: true,
                relative_urls: false,
                file_browser_callback: function (field_name, url, type, win) {
                    var x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
                    var y = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;

                    var cmsURL = "/" + 'laravel-filemanager?field_name=' + field_name;
                    if (type == 'image') {
                        cmsURL = cmsURL + "&type=Images";
                    } else {
                        cmsURL = cmsURL + "&type=Files";
                    }

                    tinyMCE.activeEditor.windowManager.open({
                        file: cmsURL,
                        title: 'Filemanager',
                        width: x * 0.8,
                        height: y * 0.8,
                        resizable: "yes",
                        close_previous: "no"
                    });
                },
                content_css: [
                    '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
                    '//www.tinymce.com/css/codepen.min.css'
                ]
            });
        }
    };

    XonBoard.Utils.documentReady(function () {
        XonBoard.Utils.init();
    });

})();
